/* eslint-disable react/require-default-props */
import { Box, Skeleton, SxProps, Theme } from '@mui/material';

type SkeletonWrapperProps = {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  skeletonSx?: SxProps<Theme>;
  variant?: 'rectangular' | 'text' | 'circular';
  width?: number | string;
  height?: number | string;
};

export function SkeletonWrapper({
  isLoading,
  sx,
  skeletonSx = {},
  variant = 'rectangular',
  width,
  height,
}: SkeletonWrapperProps): JSX.Element {
  const baseStyles: SxProps<Theme> = {
    width: '100%',
    height: '100%',
    borderRadius: 1,
  };

  return (
    <Box sx={sx}>
      {isLoading ? (
        <Skeleton
          variant={variant}
          width={width}
          height={height}
          animation="wave"
          sx={[
            baseStyles,
            ...(Array.isArray(skeletonSx) ? skeletonSx : [skeletonSx]),
          ]}
        />
      ) : null}
    </Box>
  );
}
